import { y } from '@circlefin/form'

import type { YupMessageParams } from './types'
import type { Message } from 'yup'

export const requiredMessage: Message = ({ path }: YupMessageParams) => {
  return {
    key: 'required',
    path,
  }
}

export const phoneNumberSchema = y
  .string()
  .test('invalidPhoneNumber', (value): boolean => {
    // Validator accepts empty strings and undefined
    if (value === '' || value == null) {
      return true
    }

    // Validator requires at least one digit
    return /\d/.test(value)
  })
